module.exports = "../../app/cells/pages/questions/banner_between_questions_cell.rb";